import { Component, h } from 'preact'
import { route } from 'preact-router'
import cn from 'classnames'
import { getRelativeDate } from '../../utils/date'
import { getContentByType } from '../../utils/chat'
import {
  ChatAction,
  ChatType,
  iChat,
  iChatAction,
  iMessage,
  iMessageContent,
  iUnread
} from '../../types/chat'
import { QUERY_PARAMS } from '../../constants/query'
import { iPin } from '../../types/status'
import Label from '../../UI/Label'
import Bubble from '../../UI/Bubble'
import s from './ChatPreview.css'

interface iProps {
  chatId: number
  isActive: boolean
  chat: iChat
  isOnline: boolean
  lastMessage: iMessage
  pin: iPin
  unread: iUnread
  chatAction: iChatAction
}

class ChatPreview extends Component<iProps> {
  getContent = (content: iMessageContent) => {
    const { chatAction } = this.props

    if (chatAction && chatAction.action['@type'] === ChatAction.typing) {
      return 'typing...'
    }

    return getContentByType(content)
  }

  getOnlineStatus = (type: ChatType) => {
    const { isOnline } = this.props
    return type === ChatType.private && isOnline
  }

  onKeyUpChat = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      this.handleChat()
    }
  }

  handleChat = () => {
    const { chatId } = this.props

    route(`?${QUERY_PARAMS.CHAT}=${chatId}`)
  }

  render () {
    const {
      isActive,
      chat,
      lastMessage,
      pin,
      unread
    }: iProps = this.props

    if (!chat) {
      return (
        <div
          className={s.ChatPreview}
          onClick={this.handleChat}
          onKeyUp={this.onKeyUpChat}
          tabIndex={0}
          role="button"
        >
          <div className={s.ChatPreview__avatar}/>
          <div className={s.ChatPreview__info}>
            <div className={s.ChatPreview__name}/>
            <div className={s.ChatPreview__content}/>
          </div>
          <div className={s.ChatPreview__meta}/>
        </div>
      )
    }

    const {
      title,
      type
    }: iChat = chat

    const isOnline = this.getOnlineStatus(type['@type'])
    const isUnread = unread && unread.unread_count > 0

    return (
      <div
        className={cn(s.ChatPreview, {
          [s.ChatPreview_active]: isActive
        })}
        onClick={this.handleChat}
        onKeyUp={this.onKeyUpChat}
        tabIndex={0}
        role="button"
      >
        <Bubble
          tag="div"
          className={s.ChatPreview__body}
        >
          <div className={s.ChatPreview__avatar}>
            <div className={s.ChatPreview__img}>
              <img
                src=''
                alt=""
              />
            </div>

            {isOnline && (
              <i className={s.ChatPreview__online}/>
            )}
          </div>
          <div className={s.ChatPreview__info}>
            <div className={s.ChatPreview__name}>
              {title}
            </div>
            <div className={s.ChatPreview__content}>
              {this.getContent(lastMessage.content)}
            </div>
          </div>
          <div className={s.ChatPreview__meta}>
            <div className={s.ChatPreview__date}>
              {getRelativeDate(lastMessage.date)}
            </div>

            {pin.is_pinned && !isUnread && (
              <Label>
                <i className={s.ChatPreview__pinned}/>
              </Label>
            )}

            {isUnread && (
              <Label color={isOnline ? 'green' : 'gray'}>
                {unread.unread_count}
              </Label>
            )}
          </div>
        </Bubble>
      </div>
    )
  }
}

export default ChatPreview
